import { message, Modal, Table, Space, Button, Select, Form, Input, Pagination, DatePicker, Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import useWebPost from "../../utils/useWebPost";
import FullHeightLayout from '../../components/FullHeightLayout';
import { getMonthStartEnd, checkp, formatDate, dayjsDate, formatDate2 } from '../../utils/functions'
import { PlusOutlined, EditOutlined, DeleteOutlined, DiffOutlined } from '@ant-design/icons';
import ImgUploader from "../../components/ImgUploader";
import renderFileList from "../../components/renderFileList";
import CustModal from "../../components/ShowModal";
const { Option } = Select;
function CertificateList() {
    const { type } = useParams();
    const webPost = useWebPost();
    const navigate = useNavigate();
    const [modalVisible, setModalVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({});
    const [total, setTotal] = useState(0);
    const [freshData, setfreshData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const pageSizeOptions = [10, 20, 50, 100, 500];
    const [mcolumns, setMcolumns] = useState([]);
    const [form] = Form.useForm();
    const [editingRecord, setEditingRecord] = useState(null);
    const [isGeRenZs, setIsGeRenZs] = useState(false);
    const [isGeRenZsm, setIsGeRenZsm] = useState(false);
    const [isZssy, setIsZssy] = useState(false);
    const [isZssym, setIsZssym] = useState(false);
    const [isqyzs, setIsqyzs] = useState(false);
    const [isqyzsm, setIsqyzsm] = useState(false);
    const loadingRef = useRef();
    const [titles, setTitles] = useState({});
    const [canEdit, setCanEdit] = useState(false);
    useEffect(() => {
        setCurrentPage(1);
        setFilters({});
        setfreshData(Math.random());
        const reftitle = {};
        let canmod = false, sytype='';
        switch(type){
            case '1':
                reftitle.cydw = '发证机关';
                canmod=checkp(['zxglaa']);
                setIsqyzsm(canmod);
                setIsGeRenZs(false);
                setIsqyzs(true);
                setIsZssy(false);
                sytype="企业证书";
                break;
            case '21':case '22':case '23':case '24':case '25':case '26':case '27':
                reftitle.cydw = '发证机关';
                canmod=checkp(['zxglbb'])
                setIsGeRenZsm(canmod);
                setIsGeRenZs(true);
                setIsqyzs(false);
                setIsZssy(false);
                sytype="个人证书";
                break;
            case '3':
                reftitle.cydw = '持有单位';
                canmod=checkp(['zxglcc','zssym']);
                setIsZssym(canmod);
                setIsGeRenZs(false);
                setIsqyzs(false);
                setIsZssy(true);
                sytype="证书使用";
                break;
            case '4':
                reftitle.cydw = '';
            break;
        }
        
        setTitles(prev => { return { ...prev, ...reftitle } });
        setCanEdit(canmod);
        const cols = [
            { title: '序号', dataIndex: 'sn', key: 'sn', width: 80,fixed: 'left', render: (text, record, rowIndex) => (rowIndex + 1 + (currentPage - 1) * pageSize)},
            sytype==="证书使用" && { title: '项目名称', dataIndex: 'xmmc', key: 'xmmc',ellipsis: true, width: 180,fixed: 'left',
            render:(t)=>(<div style={{width:'200px', 'overflow':'hidden',"textOverflow":'ellipsis','whiteSpace':'nowrap','display':'inline-block'}} title={t}>
                {t}
            </div>),
            },
            sytype==="证书使用" &&{ title: '姓名', dataIndex: 'holding_name', key: 'holding_name', width: 120},
            sytype==="个人证书" &&{ title: '姓名', dataIndex: 'holding_name', key: 'holding_name', width: 120},
            { title: '证书编号', dataIndex: 'certificate_number', key: 'certificate_number',fixed: 'left', width: 120 },
            { title: '证书名称', dataIndex: 'certificate_name', key: 'certificate_name',fixed: 'left', width: 120 },
            { title: '证书类型', dataIndex: 'certificate_type', key: 'certificate_type', width: 120 },
            { title: '证书状态', dataIndex: 'certificate_status', key: 'certificate_status', width: 120 },
            { title: '发证日期', dataIndex: 'issue_date', key: 'issue_date', width: 120, render: (date) => formatDate(date) },
            { title: reftitle.cydw, dataIndex: 'holding_unit', width: 120, key: 'holding_unit' },
            { title: '是否长期有效', dataIndex: 'is_long_term_valid', key: 'is_long_term_valid', width: 120, render: (text) => <span>{text ? '是' : '否'}</span> },
            { title: '有效开始日期', dataIndex: 'effective_start_date', key: 'effective_start_date', width: 120, render: (date) => formatDate(date) },
            { title: '有效结束日期', dataIndex: 'effective_end_date', key: 'effective_end_date', width: 120, render: (date) => formatDate(date) },
            { title: '证书状态', dataIndex: 'single_status', width: 120, key: 'single_status' },
            sytype==="个人证书" && {title: '录入人', dataIndex: 'creator', width: 120, key: 'creator',},
            sytype==="个人证书" && {title: '证件附件',dataIndex: 'files3',key: 'files3', width: 120,render:(_,rs)=> renderFileList(rs.files3)},
            sytype==="个人证书" && {title: '身份证', dataIndex: 'files1', key: 'files1', width: 120, render:(_,rs)=> renderFileList(rs.files1)},
            sytype==="个人证书" && {title: '毕业证',dataIndex: 'files2', key: 'files2', width: 120, render:(_,rs)=> renderFileList(rs.files2)},
            sytype==="个人证书" && {title: '照片附件',dataIndex: 'files4', key: 'files4', width: 120, render:(_,rs)=> renderFileList(rs.files4)},
            sytype==="个人证书" && {title: '劳务合同',dataIndex: 'files5', key: 'files5', width: 120, render:(_,rs)=> renderFileList(rs.files5)},
            { title: '其它附件', dataIndex: 'files', key: 'files', width: 120, render: (_, rs) => renderFileList(rs.files) },
            sytype==="个人证书" && {title: '备注',dataIndex: 'ps', width: 120, key: 'ps'},
        ].filter(Boolean);

        if (canmod) {
            cols.push({
                title: '操作',
                key: 'action',
                width: 150,
                fixed:'right',
                render: (_, record) => {
                    return (
                        <Space size="middle">
                            <Button
                                type="link"
                                icon={<EditOutlined />}
                                onClick={() => showModal(record)}
                            >
                                修改
                            </Button>
                            <Button
                                type="link"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => handleDelete(record.id)}
                            >
                                删除
                            </Button>
                        </Space>
                    )

                },
            })
        }
        setMcolumns(cols);
    }, [type]);
    useEffect(() => {
        const fetchItems = () => {
            if (loadingRef.current) return;
            loadingRef.current = true;
            setLoading(true);
            try {
                const params = { type, page: currentPage, limit: pageSize, ...filters };
                webPost('CertificateList', params).then((response) => {
                    if (response && response.data) {
                        if (response.total < 1) {
                            message.info('未找到匹配数据');
                        }
                        setData(response.data);
                        setTotal(response.total);
                    }
                })
            } catch (e) {
                setData([]);
                setTotal(0);
            } finally {
                loadingRef.current = false;
                setLoading(false);
            }
        }
        fetchItems();
    }, [currentPage, pageSize, filters, freshData]);


    const showModal = (record = null) => {
        setEditingRecord(record);
        if (record) {
            form.setFieldsValue({
                ...record,
                issue_date: dayjsDate(record?.issue_date),
                effective_start_date: dayjsDate(record?.effective_start_date),
                effective_end_date: dayjsDate(record?.effective_end_date),
            });
        } else {
            form.resetFields();
        }
        setModalVisible(true);
    };
    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                ...values, id: editingRecord?.id || 0, type, is_long_term_valid: values?.is_long_term_valid ? 1 : 0,
                issue_date: formatDate2(values?.issue_date),
                effective_start_date: formatDate2(values?.effective_start_date),
                effective_end_date: formatDate2(values?.effective_end_date),
            };

            const res = await webPost('CertificateSave', payload);
            if (res) {
                message.success(editingRecord ? '更新成功' : '新增成功');
                saveSuccess();
            }
        } catch (err) {
            console.error('表单验证或提交错误:', err);
        }
    };

    // 删除记录
    const handleDelete = async (id) => {
        Modal.confirm({
            title: '确认删除？',
            content: '此操作不可恢复',
            onOk: async () => {
                const res = await webPost('CertificateDel', { id, type });
                if (res) {
                    message.success('删除成功');
                    saveSuccess();
                } else {
                    message.error('删除失败');
                }
            },
        });
    };
    const handleModalClose = () => {
        setModalVisible(false);
        setEditingRecord(null);
    }
    const saveSuccess = () => {
        setfreshData(Math.random()); //强制刷新数据
        handleModalClose();
    };
    const onPageChange = (page, size) => {
        setCurrentPage(page);
        if (size !== pageSize) setPageSize(size);
    };
    const handleCertificateBlur = async (e) => {
        if(type !== '3')return;
        const certificateNumber = e.target.value.trim();
        const res = await webPost('CertificateByNumber', { certificateNumber });
        if (res) {
            form.setFieldsValue({...res,issue_date:dayjsDate(res?.issue_date)});
        } 

    }
    return (
        <FullHeightLayout
            headerContent={
                <Space style={{ 'display': 'flex', 'width': '100%' }}>
                    <Input value={filters?.zs} placeholder='证书编号' onChange={(e) => { setFilters(prev => ({ ...prev, zs: e.target.value })) }} />
                    <Input value={filters?.mc} placeholder='证书名称' onChange={(e) => { setFilters(prev => ({ ...prev, mc: e.target.value })) }} />
                    <Input value={filters?.zslx} placeholder='证书类型' onChange={(e) => { setFilters(prev => ({ ...prev, zslx: e.target.value })) }} />
                    <Input value={filters?.zt} placeholder='证书状态' onChange={(e) => { setFilters(prev => ({ ...prev, zt: e.target.value })) }} />
                    <Select value={filters?.cq} placeholder="是否长期有效" onChange={(v) => { setFilters(prev => ({ ...prev, mc: v })) }}>
                        <Option value={1}>是长期有效</Option>
                        <Option value={2}>不是期有效</Option>
                        <Option value={0}>不限</Option>
                    </Select>
                    <div style={{ 'flex': 1 }}></div>
                    {canEdit&&
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>
                        新建证书
                    </Button>}
                </Space>}
            bodyContent={
                <>
                    <Table
                        columns={mcolumns}
                        dataSource={data}
                        rowKey="id"
                        loading={loading}
                        pagination={false}
                        rowClassName={(rs)=>{return (isGeRenZs && rs.usage_status === 1) ? 'red2-highlight':'';}}
                        bordered
                        scroll={{
                            x: 'max-content',
                            y: 'calc(100vh - 300px)',
                        }}
                        tableLayout="fixed"
                    />
                    <CustModal
                        title={editingRecord ? '编辑证书' : '新增证书'}
                        open={modalVisible}
                        onOk={handleOk}
                        onCancel={() => setModalVisible(false)}
                        okText="保存"
                        width={700}
                    >
                        <Form form={form} layout="vertical">
                            {isZssy && (
                                <Form.Item
                                    name="xmmc"
                                    label="项目名称"
                                >
                                    <Input />
                                </Form.Item>
                            )}
                            {(isGeRenZsm || isZssy ) &&
                            <Form.Item
                                name="holding_name"
                                label="姓名"
                            >
                                <Input />
                            </Form.Item>}
                            <Form.Item
                                name="certificate_number"
                                label="证书编号"
                                rules={[{ required: true, message: '请输入证书编号' }]}
                            >
                                <Input onBlur={handleCertificateBlur} onPressEnter={handleCertificateBlur} />
                            </Form.Item>

                            <Form.Item
                                name="certificate_name"
                                label="证书名称"
                                rules={[{ required: true, message: '请输入证书名称' }]}
                            >
                                <Input />
                            </Form.Item>
                            
                            <Form.Item
                                name="certificate_type"
                                label="证书类型"
                                rules={[{ required: true, message: '请填写证书类型' }]}
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="certificate_status"
                                label="证书状态"
                            >
                                <Input />
                            </Form.Item>

                            <Form.Item
                                name="issue_date"
                                label="发证日期"
                            >
                                <DatePicker format="YYYY-MM-DD" />
                            </Form.Item>

                            <Form.Item
                                name="holding_unit"
                                label={titles.cydw}
                            >
                                <Input />
                            </Form.Item>
                            {!isZssy && (
                                <Form.Item
                                    name="is_long_term_valid"
                                    label="是否长期有效"
                                    valuePropName="checked"
                                >
                                    <Switch />
                                </Form.Item>)}

                            <Form.Item
                                name="effective_start_date"
                                label="有效开始日期"
                            >
                                <DatePicker format="YYYY-MM-DD" />
                            </Form.Item>

                            <Form.Item
                                name="effective_end_date"
                                label="有效结束日期"
                            >
                                <DatePicker format="YYYY-MM-DD" />
                            </Form.Item>

                            <Form.Item
                                name="single_status"
                                label="证书状态"
                            >
                                <Input />
                            </Form.Item>
                            {isGeRenZs && (<>
                                <Form.Item name="files1" label="身份证附件"><ImgUploader /></Form.Item>
                                <Form.Item name="files2" label="毕业证附件"><ImgUploader /></Form.Item>
                                <Form.Item name="files3" label="证件附件"><ImgUploader /></Form.Item>
                                <Form.Item name="files4" label="照片附件"><ImgUploader /></Form.Item>
                                <Form.Item name="files5" label="劳务合同"><ImgUploader /></Form.Item>
                            </>)}
                            <Form.Item
                                name="files"
                                label="其它附件"
                            >
                                <ImgUploader />
                            </Form.Item>
                        </Form>
                    </CustModal>
                </>
            }
            footerContent={
                <div style={{
                    display: 'flex', justifyContent: 'flex-end',
                    alignItems: 'center',
                }}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={total}
                        showSizeChanger
                        showQuickJumper
                        showTotal={(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`}
                        onChange={onPageChange}
                        pageSizeOptions={pageSizeOptions}
                    />
                </div>
            }
        />
    )
}


export default CertificateList;
